import { TrackNodeEvent } from "./TrackNode";
import { InputPlugin } from "./plugins/InputPlugin";
import { changeScreenshareTrackQuality, ScreenshareResolution, } from "./UserMedia/Screenshare";
import { Logger } from "../Logger";
import { LocalMediaEvent } from "./LocalMediaManager";
import { GatherEventEmitter } from "gather-common-including-video/dist/src/public/GatherEventEmitter";
import { PlayerMediaSource } from "../PlayerMediaSource";
import { newLocalScreenshareDevice } from "./SpecificLocalDevices";
import { TrackPipeline } from "./TrackPipeline";
import { buildErrorContext } from "gather-common/dist/src/public/utils";
export var ScreenshareManagerEvent;
(function (ScreenshareManagerEvent) {
})(ScreenshareManagerEvent || (ScreenshareManagerEvent = {}));
export class ScreenshareManager extends GatherEventEmitter {
    device = newLocalScreenshareDevice();
    mediaSource = new PlayerMediaSource({ playerId: "SELF_SCREENSHARE", isScreen: true });
    videoPipeline = new TrackPipeline(new InputPlugin("video", this.device));
    audioPipeline = new TrackPipeline(new InputPlugin("audio", this.device));
    screenProduction;
    soundProduction;
    resolution;
    options;
    start(screenProduction, soundProduction, options) {
        this.screenProduction = screenProduction;
        this.soundProduction = soundProduction;
        this.options = options;
        this.resolution = options.resolution;
        this.screenProduction.unmute();
        this.soundProduction.unmute();
        this.device.extendInitialSettings({
            resolution: options.resolution,
            experiment: options.experiment,
        });
        const cleanupCallbacks = [
            this.videoPipeline.input.addEventListener(TrackNodeEvent.TrackChanged, (track) => {
                if (track) {
                    this.mediaSource.addTrack(track.get());
                    this.publishEvent(LocalMediaEvent.MuteChanged, false);
                }
                else {
                    this.mediaSource.clear();
                    this.publishEvent(LocalMediaEvent.MuteChanged, true);
                }
            }, { leading: true }),
            this.videoPipeline.build([this.screenProduction]),
            this.audioPipeline.build([this.soundProduction]),
            this.device.start(),
        ];
        return () => cleanupCallbacks.forEach((c) => c());
    }
    async changeSettings(settings, reload = true) {
        const currentVideoTrack = this.videoPipeline.input.stream.getTracks()[0];
        if (Object.keys(settings).length === 1 &&
            settings.highQuality !== undefined &&
            currentVideoTrack) {
            const defaultResolution = this.resolution ?? ScreenshareResolution.HIGH;
            try {
                this.screenProduction?.stop();
                await changeScreenshareTrackQuality(currentVideoTrack, settings.highQuality, defaultResolution, { experiment: this.options?.experiment });
                this.screenProduction?.reprocess();
                await this.device.changeSettings(settings, false);
            }
            catch (e) {
                Logger.error("Error applying constraints to screen track", buildErrorContext(e));
            }
        }
        else {
            await this.device.changeSettings(settings, reload);
        }
    }
    async mute() {
        await this.device.mute();
    }
    async unmute() {
        await this.device.unmute();
    }
    debugInfo() {
        return {
            audio: this.audioPipeline.debugInfo(),
            video: this.videoPipeline.debugInfo(),
        };
    }
}
//# sourceMappingURL=ScreenshareManager.js.map